// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "input-37Jt2";
var _3 = "button-3S22v";
export { _1 as "__esModule", _2 as "input", _3 as "button" }
export default { "__esModule": _1, "input": _2, "button": _3 }
